/**
 * Track context based on cursor position and return the correct context to
 * display hints for users.
 * @module contextualKeywordsState
 * @category CodeMirror
 */

import { StateField } from "@codemirror/state";
import { type KeywordsType, keywords, keywordsRegExString, strings } from "@quickpoint.me/shared";

export const contextualKeywordsState: StateField<KeywordsType | typeof strings.context.topLevel> = StateField.define({
  create() {
    return strings.context.init;
  },
  update(value: any, tr) {
    const regex = keywordsRegExString(keywords);
    const keywordRegex = new RegExp(regex, "i");
    const tabRegEx = new RegExp(/\t|\s\s/g);

    // if it's not an update that changes the selection, clicking, typing.. then return the previous value.
    if (!tr.selection) return value;

    tr.state.selection.ranges
      .filter((range) => range.empty)
      .map((range) => {
        let line = tr.state.doc.lineAt(range.head);

        let lineNumber = line.number;
        // if its a tab keep going back until it finds an un-tabbed line
        let tabMatch = line.text.match(tabRegEx);
        while (tabMatch) {
          if (!lineNumber || lineNumber <= 1) break;
          lineNumber--;
          line = tr.state.doc.line(lineNumber);
          tabMatch = line.text.match(tabRegEx);
        }
        // if the lines is empty we're at the top-level. No code. No modifiers. NoTabs
        if (line.text === "" && !tabMatch) value = strings.context.topLevel;
        // start looking for matches.
        const match = line.text.match(keywordRegex);

        // if there's a keyword in the line show it's modifiers
        if (match) {
          const keyword = match[0];
          value = keyword;
        }
        // if there's text with no keyword and no tab then it's considered a paragraph
        // @ts-ignore
        if (!match && line.length > 0 && !tabMatch) value = "paragraph:";
      });

    return value;
  },
});
